import Colors from '@digili-ui/constants/colors'
import {
  Collapsible as DSCollapsible,
  CollapsibleProps as DSCollapsibleProps,
} from '@s-group/design-system-components/Collapsible/Collapsible'
import { styled } from 'styled-components'

export type CollapsibleProps = DSCollapsibleProps

const UnstyledCollapsible = (props: CollapsibleProps) => {
  return <DSCollapsible {...props} />
}

export const Collapsible = styled(UnstyledCollapsible)`
  background-color: ${Colors.White};
  width: 100%;
`
